import { calculateDeadline } from "../../utils/time";
const prepareUserRequest = (offerAmount, atomicPrice, deadline) => {
  const deadlineTimeStamp = calculateDeadline(deadline);
  return {
    deadline: deadlineTimeStamp,
    atomicPrice,
    offerAmount,
    inSolve: false
  };
};
const calculateAtomicPrice = (rateInQuote, wantAssetDecimals, slippage) => {
  const wantPrecision = BigInt(10 ** wantAssetDecimals);
  const slippageAsBigInt = BigInt(slippage) * wantPrecision / BigInt(1e4);
  return rateInQuote * (wantPrecision - slippageAsBigInt) / wantPrecision;
};
export {
  calculateAtomicPrice,
  prepareUserRequest
};
//# sourceMappingURL=utils.mjs.map